module.exports = __webpack_public_path__ + "img/face94.ce170402.gif";